import { SizableText, Stack, YStack } from '@mythical/ui'
import ContentEpisodeListItem from './ContentEpisodesListItem'
import Spinner from 'app/components/primitive/Spinner'
import { Select } from 'app/components/primitive/Form'
import { FlatList } from 'react-native'
import { FullScreenOverlay } from 'app/components/primitive/FullScreenOverlay'
import { ContentEpisodesListProps } from './ContentEpisodesListProps'

const VERTICAL_SPACING = 12
const VERTICAL_HEIGHT = 175 + VERTICAL_SPACING

export const ContentEpisodesListVertical = (
  props: ContentEpisodesListProps,
) => {
  const {
    title,
    currentContentId,
    loading,
    episodes = [],
    seasons,
    season,
    onSeasonChange,
    onContentClick,
    ...stackProps
  } = props

  const handleSeasonChange = (season: string) => {
    onSeasonChange?.(season)
  }

  const initialScrollIndex = episodes.findIndex(
    (item) => item.id === currentContentId,
  )

  return (
    <YStack
      bg="$bgPrimary"
      br="$3"
      py="$3.5"
      w="100%"
      jc="space-between"
      ai="flex-start"
      gap="$3.5"
      maw={270}
      mah={630}
      bw={2}
      boc="$borderSecondary"
      h="100%"
      {...stackProps}
    >
      <YStack w="100%" jc="flex-start" flexWrap="wrap" px="$3.5" gap="$3.5">
        <SizableText tag="h2" size="$5" fow="600">
          {title}
        </SizableText>
        {!!seasons && seasons.length > 1 && (
          <Select
            id="seasons-vertical"
            hideLabel
            theme="bgSecondaryOutlined"
            name="seasons-vertical"
            label="Select season"
            value={season}
            onValueChange={handleSeasonChange}
            options={seasons}
            fullWidth
            size="$3"
            triggerProps={{ br: '$pill' }}
          />
        )}
      </YStack>

      <Stack w="100%" fg={1} fs={1} px={4}>
        {loading && episodes.length === 0 && (
          <FullScreenOverlay>
            <Spinner size="large" />
          </FullScreenOverlay>
        )}

        <FlatList
          data={episodes}
          keyExtractor={(item) => item.id}
          nestedScrollEnabled
          renderItem={({ item }) => (
            <Stack h={VERTICAL_HEIGHT}>
              <ContentEpisodeListItem
                {...item}
                isActive={currentContentId === item.id}
                onNavigate={(e) => {
                  e.preventDefault()
                  onContentClick?.(item.id)
                }}
              />
            </Stack>
          )}
          initialScrollIndex={initialScrollIndex > -1 ? initialScrollIndex : 0}
          style={{
            paddingHorizontal: 12,
            marginBottom: -VERTICAL_SPACING,
          }}
          getItemLayout={(_, index) => {
            return {
              length: VERTICAL_HEIGHT,
              offset: index * VERTICAL_HEIGHT,
              index,
            }
          }}
        />
      </Stack>
    </YStack>
  )
}
